import React, { FC } from 'react';
import { Destination } from 'src/common/types/api/v4/boats/search';
import UniversalLink, { UniversalLinkProps } from 'src/common/components/UniversalLink';

import Typography from 'src/common/components/Typography/index';
import styles from './TopDestination.module.scss';

export type DestinationSimple = Pick<Destination, 'slug' | 'breadcrumbs' | 'boat_count'>;

export type TopDestinationProps = {
  destination: DestinationSimple;
  href: UniversalLinkProps['href'];
};

/**
 * This component returns an `<li>`
 *  and should always be wrapped in a `<ul>` for accessibility
 * Still used in Search page; only deprecated for Dlp
 */
const TopDestination: FC<TopDestinationProps> = (
  { destination, href },
) => {
  if (!destination) {
    return null;
  }
  return (
    <li className={styles.li}>
      <UniversalLink
        href={href}
        className={styles.item}
      >
        <div className={styles.listingCount}>
          <Typography
            size="body-s"
            sizeFromBreakpointM="body-m"
            type="p"
          >
            {destination.boat_count}
          </Typography>
        </div>
        <div>
          <Typography
            size="body-m"
            type="p"
            weight="semibold"
          >
            {destination.breadcrumbs[destination.breadcrumbs.length - 1].name}
          </Typography>
          {destination.breadcrumbs.length > 1 && (
            <Typography
              size="body-s"
              type="p"
              className={styles.subtitle}
            >
              {destination.breadcrumbs[destination.breadcrumbs.length - 2].name}
            </Typography>
          )}
        </div>
      </UniversalLink>
    </li>
  );
};

export default TopDestination;
